<template>
  <div>
    <sortPrice @sortType="sortType"></sortPrice>
    <productionList :productlist="datas"></productionList>
  </div>
</template>
<script>
import productionList from '@/components/productList'
import { sortPrice } from './components'
import scroll from '@/mixins/scroll'
import { goodsList } from '@/api/goods'

export default {
  components: {
    productionList,
    sortPrice
  },
  data () {
    return {
      datas: []
    }
  },
  mixins: [scroll],
  methods: {
    async getList (sortType = {}) {
      //判断是几级分类
      const routerCateType = this.$route.query.cate_type
      const cate_type = {
        ['1']: 'first_cat_id',
        ['2']: 'second_cat_id',
        ['3']: 'third_cat_id'
      }

      const result = await goodsList({
        //筛选
        ...sortType,
        page: this.page,
        size: 6,
        keyword: this.$route.query.keyword || null,
        [cate_type[routerCateType]]: this.$route.query.cat_id || null,
      })
      if (result.data.data.goodsList.data.length !== 0) {
        console.log(this.datas)
        this.datas = this.datas.concat(result.data.data.goodsList.data)
      } else {
        this.page = null
      }
    },
    sortType (value) {
      this.datas = []
      this.getList(value)
    },
  },
  created () {
    if (this.page == 0) {
      this.page += 1
      this.getList()
    }
  },
}
</script>
<style lang="scss" scoped>
</style>